export default function(ring) {
  if ((n = ring.length) < 4) return false;
  var i = 0,
      n,
      area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area <= 0;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo-projection/src/project/clockwise.js
// module id = 746
// module chunks = 0